module.exports = __webpack_public_path__ + "media/entry_pass/bck_img-0e7477d3.png";